/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon20Light = forwardRef('TextBulletIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M7 4.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M7.5 9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z" }),
        React.createElement("path", { d: "M7.5 14a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z" }),
        React.createElement("path", { d: "M5 9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M4 15.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
